<template>
  <section>
    <div class="container pb-4">
      <div class="row">
        <div class="col-lg-12">
          <h4 class="mt-5">我的钱包
            <el-tag v-if="balance!=null" type="success">￥{{balance}}</el-tag>
          </h4>
          <el-row :gutter="12">
            <el-col :class="item.IsMainUse==1?'primary':'gray'" v-for="item in wallets" :key="item.ID" :span="8">
              <el-card shadow="always">
                <div slot="header" class="clearfix">
                  <span><el-tag size="small" v-if="item.IsMainUse==1">主卡</el-tag> {{item.BankName}}{{item.PartBankName?(','+item.PartBankName):''}}</span>
                  <el-dropdown style="float: right; padding: 3px 0" @command="handleCommand">
                    <span class="el-dropdown-link action">
                      操作<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item :command="{c:'setMain',d:item}">设为主卡</el-dropdown-item>
                      <el-dropdown-item :command="{c:'delete',d:item}">删除</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
                <div class="cardNumber">
                  卡号:{{item.CardNumber}}
                </div>
              </el-card>
            </el-col>
            <el-col :span="8">
              <el-card shadow="always">
                <div class="add_card" @click="addNewCard">
                  <i class="el-icon-plus"></i>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <el-dialog class="add_card_dialog" title="新增银行卡" :visible.sync="dialogFormVisible">
      <el-form size="mini" style="margin-top:30px;margin-right:30px;" :model="form" label-width="80px">
        <el-form-item label="开户行">
          <el-select class="full-width" v-model="form.BankCode">
            <el-option v-for="item in bankCodes" :key="item.ID" :label="item.Name" :value="item.ID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分行">
          <el-input v-model="form.PartBankName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="卡号">
          <el-input v-model="form.CardNumber" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item>
          设为主卡
          <el-switch v-model="form.IsMainUse">
          </el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveWallet">确 定</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
  import api from "../api";
  export default {
    data() {
      return {
        dialogFormVisible: false,
        balance: null,
        form: {},
        wallets: [],
        bankCodes: []
      };
    },
    methods: {
      addNewCard() {
        let _this = this;
        _this.dialogFormVisible = true;
      },
      saveWallet() {
        let _this = this;
        let bankName = _this.bankCodes.filter(item => {
          return item.ID == _this.form.BankCode
        })[0].Name;
        let wallet = {
          BankName: bankName,
          CardNumber: _this.form.CardNumber,
          BankCode: _this.form.BankCode,
          PartBankName: _this.form.PartBankName,
          IsMainUse: _this.form.IsMainUse ? 1 : 0
        }
        _this.doSaveWallet(wallet)
      },
      handleCommand(command) {
        if (command.c == "delete") {
          this.$confirm("此操作将永久删除该卡片, 是否继续?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            })
            .then(() => {
              this.deleteCard(command.d);
            })
            .catch(() => {});
        } else if (command.c == "setMain") {
          let wallet = command.d;
          wallet.IsMainUse = 1;
          this.doSaveWallet(wallet);
        }
      },
      deleteCard(item) {
        let _this = this;
        api
          .deleteWallet({
            Id: item.ID
          })
          .then(res => {
            if (res.data.Succeed) {
              _this.$message({
                type: "success",
                message: "删除成功!"
              });
              _this.loadData();
            }
          });
      },
      loadData() {
        let _this = this;
        api.getWallets().then(res => {
          if (res.data.Succeed) {
            _this.wallets = res.data.Data;
            _this.balance = res.data.Balance;
          }
        });
      },
      doSaveWallet(wallet) {
        let _this = this;
        api.saveWallet(wallet).then(res => {
          if (res.data.Succeed) {
            _this.dialogFormVisible = false;
            _this.loadData();
          }
        });
      },
      getDictionaries() {
        let _this = this
        api
          .getDictionary({
            search: {
              IsEnabled: "",
              PageNo: 1,
              PageSize: 1000
            },
            tableName: "BankCode"
          })
          .then(res => {
            _this.bankCodes = res.data.Data.Data;
          });
      }
    },
    mounted() {
      this.loadData()
      this.getDictionaries()
    }
  };
</script>

<style scoped>
  span.action {
    color: #409eff !important;
  }
  .col-lg-12 {
    min-height: 700px;
  }
  .cardNumber {
    padding-top: 40px;
    padding-bottom: 10px;
  }
  .add_card {
    text-align: center;
    font-size: 50px;
    line-height: 2.7;
    cursor: pointer;
  }
  .add_card i {
    color: #aaa;
  }
  .el-col {
    margin-top: 16px;
  }
  .full-width {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Wallet.vue